// Generated by CoffeeScript 2.7.0
var UserBoundarySelectorModal, dynamic_reviewer_comp, modal_comp, user_boundary_comp;

import Modal from 'trunks/vue/admin/components/modals/modal.js';

import UserBoundary from 'trunks/vue/admin/components/user_boundary.js';

import DynamicReviewer from 'trunks/vue/admin/components/yet_another_workflow/dynamic_reviewer.js';

modal_comp = Modal;

user_boundary_comp = UserBoundary;

dynamic_reviewer_comp = DynamicReviewer;

export default UserBoundarySelectorModal = Vue.extend({
  components: {
    'user-boundary': user_boundary_comp,
    'modal': modal_comp,
    'dynamic-reviewer': dynamic_reviewer_comp
  },
  props: {
    userBoundary: Object,
    extraBoundaryComps: Array
  },
  data: function() {
    return {
      result: this.userBoundary
    };
  },
  template: `<modal title='选择范围'
       extendClass='user-boundary-select-modal'
       :backdrop='true'
       ref='modal'>
  <div class="user-boundary-wrapper">
    <user-boundary ref='userBoundary' :userBoundary='userBoundary' @valueChanged='updateResult' />
    <component v-for="item in extraBoundaryComps" :is="item.name" v-bind="item" @valueChanged='updateExtraBoundary'></component>
  </div>
  <div class="modal-footer" slot='footer'>
    <div class="left"></div>
    <div>
      <button class="outlined btn-default" @click='dismissModal'>取消</button>
      <button @click='saveChanges'>确定</button>
    </div>
  </div>
</modal>`,
  created: function() {
    return this.extraBoundary = {};
  },
  methods: {
    dismissModal: function() {
      return this.$refs.modal.close();
    },
    updateResult: function(ub_vm) {
      return this.result = ub_vm.getData();
    },
    updateExtraBoundary: function(options) {
      return _.extend(this.extraBoundary, options);
    },
    saveChanges: function() {
      this.$emit('ensureClicked', this.$refs.userBoundary.getValue(), this.extraBoundary);
      return this.$refs.modal.close();
    }
  }
});
